import type { IsoDate, Reservation } from '@kratispot/shared';

export type CellKind = 'empty' | 'start' | 'mid' | 'end' | 'whole';

export type CalendarCell = {
  readonly date: IsoDate;
  readonly kind: CellKind;
  readonly booking: Reservation | null;
};

export function bookingOn(
  bookings: readonly Reservation[],
  spotId: string,
  date: IsoDate,
): Reservation | null {
  return (
    bookings.find(
      (booking) => booking.spotId === spotId && booking.startsOn <= date && booking.endsOn >= date,
    ) ?? null
  );
}

// A stay is one block: only the day it starts carries the guest's name.
export function cellsFor(
  spotId: string,
  bookings: readonly Reservation[],
  days: readonly IsoDate[],
): CalendarCell[] {
  return days.map((date) => {
    const booking = bookingOn(bookings, spotId, date);
    if (booking === null) return { date, kind: 'empty', booking: null };
    const starts = booking.startsOn === date;
    const ends = booking.endsOn === date;
    if (starts && ends) return { date, kind: 'whole', booking };
    return { date, kind: starts ? 'start' : ends ? 'end' : 'mid', booking };
  });
}

export function labelOf(cell: CalendarCell): string {
  if (cell.booking === null) return '';
  return cell.kind === 'start' || cell.kind === 'whole' ? cell.booking.guestName : '';
}
